// please leave the order as it is since it's mirrored from error-codes.enum.ts

export enum EErrorMessage {
  UNKNOWN = `unknown`,
  NOT_FOUND = `notFound`,
  BAD_REQUEST = `badRequest`,
  LOGIN_FAILED = `loginFailed`,
  LOGIN_FAILED_REQ_CAPTCHA = `loginFailedReqCaptcha`,
  LOGIN_FAILED_LOCKED = `loginFailedLocked`,
  FORBIDDEN = `forbidden`,
  SESSION_REQUIRED = `sessionRequired`,
  UNAUTHORIZED = `unauthorized`,
  UNEXPECTED_RESPONSE = `unexpectedResponse`,
  VALIDATION_FAILED = `validationFailed`,
  CN_MISSING_FOR_TOKEN = `cnMissingForToken`,
  PRODUCTS_UPDATE = `productsUpdate`,
  PRODUCT_INFOS_UPDATE = `productInfosUpdate`,
  FETCH_ERROR = `fetchError`,
  REDIS_ERROR = `redisError`,
  INSTAGRAM_ERROR = `instagramError`,
  GET_PRODUCT_INFOS = `getProductInfos`,
  SPLIT_RUN_COOKIE = `splitRunCookie`,
  VALIDATION_PARAMETER_FAILED = `validationParameterFailed`,
  FETCH_NO_RESPONSE = `fetchNoResponse`,
  FETCH_UNEXPECTED = `fetchUnexpectedError`,
  LOGGING_UNEXPECTED = `loggingUnexpected`,
  ROUTE_NOT_FOUND = `routeNotFound`,

  // Infoworx Responses from ApiService
  INFOWORX_RESPONSE_DATA_MISSING = `infoworxResponse.dataMissing`,
  INFOWORX_RESPONSE_GET_CUSTOMER = `infoworxResponse.getCustomer`,
  INFOWORX_RESPONSE_GET_PRODUCTS = `infoworxResponse.getProducts`,
  INFOWORX_RESPONSE_GET_SALUTATIONS = `infoworxResponse.getSalutations`,
  INFOWORX_RESPONSE_GET_COUNTRIES = `infoworxResponse.getCountries`,
  INFOWORX_RESPONSE_GET_CURRENCIES = `infoworxResponse.getCurrencies`,
  INFOWORX_RESPONSE_GET_LANGUAGES = `infoworxResponse.getLanguages`,
  INFOWORX_RESPONSE_GET_ACQUISITIONS = `infoworxResponse.getAcquisitions`,
  INFOWORX_RESPONSE_GET_CART_TYPES = `infoworxResponse.getCartTypes`,
  INFOWORX_RESPONSE_GET_STRING = `infoworxResponse.getString`,
  INFOWORX_RESPONSE_GET_COUPON_INFOS = `infoworxResponse.getCouponInfos`,
  INFOWORX_RESPONSE_GET_CONTACT_TYPES = `infoworxResponse.getContactTypes`,
  INFOWORX_RESPONSE_CONFIRM_EMAIL = `infoworxResponse.confirmEmail`,
  INFOWORX_RESPONSE_ADD_CUSTOMER = `infoworxResponse.addCustomer`,
  INFOWORX_RESPONSE_ADD_CUSTOMER_EXTERNAL = `infoworxResponse.addCustomerExternal`,
  INFOWORX_RESPONSE_REMOVE_CART = `infoworxResponse.removeCart`,
  INFOWORX_RESPONSE_GET_CART = `infoworxResponse.getCart`,
  INFOWORX_RESPONSE_GET_CART_COUNT = `infoworxResponse.getCartCount`,
  INFOWORX_RESPONSE_ADD_CART_ITEM = `infoworxResponse.addCartItem`,
  INFOWORX_RESPONSE_REMOVE_CART_ITEM = `infoworxResponse.removeCartItem`,
  INFOWORX_RESPONSE_SEND_PASSWORD_EMAIL = `infoworxResponse.sendPasswordEmail`,
  INFOWORX_RESPONSE_UPDATE_CART_ITEM = `infoworxResponse.updateCartItem`,
  INFOWORX_RESPONSE_GET_ADDRESSES = `infoworxResponse.getAddresses`,
  INFOWORX_RESPONSE_GET_CONTACTS = `infoworxResponse.getContacts`,
  INFOWORX_RESPONSE_UPDATE_CONTACT = `infoworxResponse.updateContact`,
  INFOWORX_RESPONSE_REMOVE_CONTACT = `infoworxResponse.removeContact`,
  INFOWORX_RESPONSE_GET_ORDERS = `infoworxResponse.getOrders`,
  INFOWORX_RESPONSE_CANCEL_ORDER = `infoworxResponse.cancelOrder`,
  INFOWORX_RESPONSE_UPDATE_ADDRESS = `infoworxResponse.updateAddress`,
  INFOWORX_RESPONSE_ADD_COUPON = `infoworxResponse.addCoupon`,
  INFOWORX_RESPONSE_ADD_SUPPLEMENT = `infoworxResponse.addSupplement`,
  INFOWORX_RESPONSE_UPDATE_PASSWORD = `infoworxResponse.updatePassword`,
  INFOWORX_RESPONSE_UPDATE_CUSTOMER = `infoworxResponse.updateCustomer`,
  INFOWORX_RESPONSE_REMOVE_ADDRESS = `infoworxResponse.removeAddress`,
  INFOWORX_RESPONSE_GET_CUSTOMER_TRANSFER = `infoworxResponse.getCustomerTransfer`,
  INFOWORX_RESPONSE_CUSTOMER_TRANSFER = `infoworxResponse.customerTransfer`,
  INFOWORX_RESPONSE_RESEND_CUSTOMER_TRANSFER = `infoworxResponse.resendCustomerTransfer`,
  INFOWORX_RESPONSE_CONFIRM_CUSTOMER_TRANSFER = `infoworxResponse.confirmCustomerTransfer`,
  INFOWORX_RESPONSE_GET_NEW_CUSTOMERS = `infoworxResponse.getNewCustomers`,
  INFOWORX_RESPONSE_CHECKOUT_ADDRESSES = `infoworxResponse.checkoutAddresses`,
  INFOWORX_RESPONSE_CHECKOUT_DELIVERY_TYPES = `infoworxResponse.checkoutDeliveryTypes`,
  INFOWORX_RESPONSE_CHECKOUT_PAYMENT_TERMS = `infoworxResponse.checkoutPaymentTypes`,
  INFOWORX_RESPONSE_CHECKOUT_SUMMARY = `infoworxResponse.checkoutSummary`,
  INFOWORX_RESPONSE_CHECKOUT_FINISH = `infoworxResponse.checkoutFinish`,
  INFOWORX_RESPONSE_PAYMENT = `infoworxResponse.payment`,
  INFOWORX_RESPONSE_GET_PARTNER_DATA = `infoworxResponse.getPartnerData`,
  INFOWORX_RESPONSE_UPDATE_PARTNER_DATA = `infoworxResponse.updatePartnerData`,
  INFOWORX_RESPONSE_UPLOAD_PARTNER_PICTURE = `infoworxResponse.uploadPartnerPicture`,
  INFOWORX_RESPONSE_INVOICING_POINTS = `infoworxResponse.invoicingPoints`,
  INFOWORX_RESPONSE_GET_INVOICING = `infoworxResponse.getInvoicing`,
  INFOWORX_RESPONSE_GET_INVOICING_NUMBERS = `infoworxResponse.getInvoicingNumbers`,
  INFOWORX_RESPONSE_UPDATE_NEWSLETTER = `infoworxResponse.updateNewsletter`,
  INFOWORX_RESPONSE_UNSUBSCRIBE_NEWSLETTER = `infoworxResponse.unsubscribeNewsletter`,
  INFOWORX_RESPONSE_CONFIRM_NEWSLETTER = `infoworxResponse.confirmNewsletter`,
  INFOWORX_RESPONSE_GET_TRANSACTIONS = `infoworxResponse.getTransactions`,
  INFOWORX_RESPONSE_GET_PARTNER_PAGE = `infoworxResponse.getPartnerPage`,
  INFOWORX_RESPONSE_SEARCH_PARTNER = `infoworxResponse.searchPartner`,
  INFOWORX_RESPONSE_GET_PARTNER_PAGE_SESSION = `infoworxResponse.getPartnerPageSession`,
  INFOWORX_RESPONSE_SEND_PARTNER_APPLICATION = `infoworxResponse.sendPartnerApplication`,
  INFOWORX_RESPONSE_GET_PARTNER_APPLICATION = `infoworxResponse.getPartnerApplication`,
  INFOWORX_RESPONSE_GET_NEW_VENDORS = `infoworxResponse.getNewVendors`,
  INFOWORX_RESPONSE_TEAM_STRUCTURE = `infoworxResponse.teamStructure`,
  INFOWORX_RESPONSE_GET_GENERATIONS = `infoworxResponse.getGenerations`,
  INFOWORX_RESPONSE_SEARCH_TEAM = `infoworxResponse.searchTeam`,
  INFOWORX_RESPONSE_SEARCH_TEAM_EXPORT = `infoworxResponse.searchTeamExport`,
  INFOWORX_RESPONSE_CONFIRM_CUSTOMER = `infoworxResponse.confirmCustomer`,
  INFOWORX_RESPONSE_TARGETLEVEL_BAROMETER = `infoworxResponse.targetlevelBarometer`,
  INFOWORX_RESPONSE_GET_SETTINGS = `infoworxResponse.getSettings`,
  INFOWORX_RESPONSE_UPDATE_SETTINGS = `infoworxResponse.updateSettings`,
  INFOWORX_RESPONSE_UPDATE_NEW_CUSTOMER = `infoworxResponse.updateNewCustomer`,
  INFOWORX_RESPONSE_GET_INVOICES = `infoworxResponse.getInvoices`,
  INFOWORX_RESPONSE_REVENUE_STATISTICS = `infoworxResponse.revenueStatistics`,
  INFOWORX_RESPONSE_REVENUE_STATISTIC_TEAM = `infoworxResponse.revenueStatisticTeam`,
  INFOWORX_RESPONSE_REVENUE_QUERY = `infoworxResponse.revenueQuery`,
  INFOWORX_RESPONSE_REVENUE_QUERY_TEAM = `infoworxResponse.revenueQueryTeam`,
  INFOWORX_RESPONSE_INCENTIVES = `infoworxResponse.incentives`,
  INFOWORX_RESPONSE_GET_INCENTIVE_RANKING = `infoworxResponse.getIncentiveRanking`,
  INFOWORX_RESPONSE_GET_INCENTIVE_CLIMBER_RANKING = `infoworxResponse.getIncentiveClimberRanking`,
  INFOWORX_RESPONSE_GET_INCENTIVE_DATA = `infoworxResponse.getIncentiveData`,
  INFOWORX_RESPONSE_GET_UPLINE = `infoworxResponse.getUpline`,
  INFOWORX_RESPONSE_MEMBER_CUSTOMER = `infoworxResponse.memberCustomer`,
  INFOWORX_RESPONSE_MEMBER_TEAM = `infoworxResponse.memberTeam`,
  INFOWORX_RESPONSE_MEMBER_TEAM_CUSTOMER = `infoworxResponse.memberTeamCustomer`,
  INFOWORX_RESPONSE_GET_DASHBOARD = `infoworxResponse.getDashboard`,
  INFOWORX_RESPONSE_TEAM_INACTIVE_VENDORS = `infoworxResponse.teamInactiveVendors`,
  INFOWORX_RESPONSE_TEAM_NEWLY_REACHED_TARGETLEVELS = `infoworxResponse.teamNewlyReachedTargetlevels`,
  INFOWORX_RESPONSE_TEAM_NEW_VENDOR_VOLUME = `infoworxResponse.newVendowVolume`,
  INFOWORX_RESPONSE_GET_COUPONS = `infoworxResponse.getCoupons`,
  INFOWORX_RESPONSE_GET_CALENDAR = `infoworxResponse.getCalendar`,
  INFOWORX_RESPONSE_TEAM_GROWTH = `infoworxResponse.teamGrowth`,
  INFOWORX_RESPONSE_GET_TEAM_COUNTS = `infoworxResponse.getTeamCounts`,
  INFOWORX_RESPONSE_UPDATE_PARTNER_PAGE = `infoworxResponse.updatePartnerPage`,
  INFOWORX_RESPONSE_GET_SUBDOMAINS = `infoworxResponse.getSubdomains`,
  INFOWORX_RESPONSE_ADD_SUBDOMAIN = `infoworxResponse.addSubdomain`,
  INFOWORX_RESPONSE_TEAM_RANKINGS = `infoworxResponse.teamRankings`,
  INFOWORX_RESPONSE_GET_RECENT_INVOICES = `infoworxResponse.getRecentInvoices`,
  INFOWORX_RESPONSE_GET_DATASHEET = `infoworxResponse.getDatasheet`,
  INFOWORX_RESPONSE_SEARCH_INCENTIVE_PARTNER = `infoworxResponse.searchIncentivePartner`,
  INFOWORX_RESPONSE_VOTE_INCENTIVE_PARTNER = `infoworxResponse.voteIncentivePartner`,
  INFOWORX_RESPONSE_GET_FAVOURITE_PRODUCTS = `infoworxResponse.getFavouriteProducts`,
  INFOWORX_RESPONSE_GET_FAIR_SCORE = `infoworxResponse.getFairScore`,
  INFOWORX_RESPONSE_GET_SESSION_CUSTOMER = `infoworxResponse.getSessionCustomer`,
  INFOWORX_RESPONSE_GET_DOWNLINE = `infoworxResponse.getDownline`,
  INFOWORX_RESPONSE_GET_PAYMENT_DATA = `infoworxResponse.getPaymentData`,
  INFOWORX_RESPONSE_UPDATE_PAYMENT = `infoworxResponse.updatePayment`,
  INFOWORX_RESPONSE_SET_FRESHCHAT_REFERENCE = `infoworxResponse.setFreshchatReference`,
  INFOWORX_RESPONSE_GET_PARTNER_DASHBOARD = `infoworxResponse.getPartnerDashboard`,
  INFOWORX_RESPONSE_GET_PAYMENT_PROVIDERS = `infoworxResponse.getPaymentProviders`,
  INFOWORX_RESPONSE_GET_PAYMENT_METHODS = `infoworxResponse.getPaymentMethods`,
  INFOWORX_RESPONSE_GET_PAYMENT_TOKENS = `infoworxResponse.getPaymentTokens`,
  INFOWORX_RESPONSE_ADD_PAYMENT_TOKEN_CREDIT_CARD = `infoworxResponse.addPaymentTokenCreditCard`,
  INFOWORX_RESPONSE_ADD_PAYMENT_TOKEN_PAYPAL = `infoworxResponse.addPaymentTokenPaypal`,
  INFOWORX_RESPONSE_SEND_VENDOR_RECOMMENDATION = `infoworxResponse.sendVendorRecommendation`,
  INFOWORX_RESPONSE_GET_VENDOR_DATA = `infoworxResponse.getVendorData`,
  INFOWORX_RESPONSE_CHECKOUT_ONECLICK = `infoworxResponse.checkoutOneclick`,
  INFOWORX_RESPONSE_UPDATE_PAYMENT_NOTIFICATION = `infoworxResponse.updatePaymentNotification`,
  INFOWORX_RESPONSE_DELETE_PAYMENT_TOKEN = `infoworxResponse.deletePaymentToken`,

  CAPTCHA_WRONG = `captchaWrong`,
  GONE = `gone`,
}
